export const DASHBOARD_TO_ADD_TO_PARAM = 'dashboardToAddTo';
export const DASHBOARD_LAYOUT_ROW_ID_PARAM = 'dashboardLayoutRowID';
export const DASHBOARD_CONTEXT = 'dashboardContext';
export const DASHBOARD_LAYOUT_CELL_INSERT_DIRECTION =
  'dashboardLayoutCellInsertDir';
export const SHOULD_CLONE_DASHBOARD = 'shouldCloneDashboard';
export const REDIRECT_TO = 'et_redirectTo';
